import { _ as e, x as i } from "./export-cdcbfb2b.js";
import { f } from "./function-uncurry-this-clause-99074d1c.js";
import { a as o } from "./array-method-is-strict-e5a3c878.js";
var d = e, s = f, u = i.indexOf, x = o, r = s([].indexOf), n = !!r && 1 / r([1], 1, -0) < 0, v = n || !x("indexOf");
d({ target: "Array", proto: !0, forced: v }, {
  indexOf: function(a) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return n ? r(this, a, t) || 0 : u(this, a, t);
  }
});
